/**
 * Gestion globale des boutons Wishlist.
 * La délégation d'événement permet aussi de gérer les cartes produit chargées
 * en AJAX dans la section Produits recommandés d'Horizon.
 */

if (!window.wishlistButtonEventsBound) {
  window.wishlistButtonEventsBound = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-wishlist-toggle]');

    if (!button || button.getAttribute('aria-busy') === 'true') return;

    event.preventDefault();

    const productId = button.dataset.productId;
    const endpoint = button.dataset.endpoint;
    const wasActive = button.getAttribute('aria-pressed') === 'true';
    const action = wasActive ? 'remove' : 'add';

    if (!productId || !endpoint) return;

    setBusyState(button, true);

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          action,
          product_id: productId,
        }),
      });

      const result = await response.json().catch(() => ({}));

      if (!response.ok || result.ok === false) {
        throw new Error(result.message || `Erreur HTTP ${response.status}`);
      }

      const isActive = typeof result.active === 'boolean' ? result.active : action === 'add';

      updateProductButtons(productId, isActive);
      updateWishlistCount(result.count);

      if (!isActive && button.hasAttribute('data-wishlist-remove-from-page')) {
        removeProductFromWishlistPage(productId);
      }

      document.dispatchEvent(
        new CustomEvent('wishlist:updated', {
          detail: {
            productId,
            active: isActive,
            count: result.count,
          },
        })
      );
    } catch (error) {
      announce(button, error.message || 'Impossible de mettre à jour les favoris.');
      console.error('Wishlist:', error);
    } finally {
      setBusyState(button, false);
    }
  });
}

function setBusyState(button, isBusy) {
  button.setAttribute('aria-busy', String(isBusy));
}

function updateProductButtons(productId, isActive) {
  const selector = `[data-wishlist-toggle][data-product-id="${CSS.escape(String(productId))}"]`;

  document.querySelectorAll(selector).forEach((button) => {
    const label = isActive ? button.dataset.removeLabel : button.dataset.addLabel;
    const text = button.querySelector('[data-wishlist-button-label]');

    button.setAttribute('aria-pressed', String(isActive));
    button.classList.toggle('wishlist-add-button__control--active', isActive);
    button.setAttribute('aria-label', label);
    button.setAttribute('title', label);

    if (text) text.textContent = label;

    announce(button, label);
  });
}

function updateWishlistCount(count) {
  const numericCount = Number(count);

  if (!Number.isFinite(numericCount)) return;

  const normalizedCount = Math.max(0, Math.trunc(numericCount));

  document.querySelectorAll('[data-wishlist-count]').forEach((counter) => {
    counter.textContent = String(normalizedCount);
    counter.hidden = normalizedCount === 0;
    counter.setAttribute(
      'aria-label',
      `${normalizedCount} produit${normalizedCount > 1 ? 's' : ''} dans les favoris`
    );
  });

  document.querySelectorAll('[data-wishlist-link]').forEach((link) => {
    link.setAttribute(
      'aria-label',
      normalizedCount > 0
        ? `Voir ma liste d’envies — ${normalizedCount} produit${normalizedCount > 1 ? 's' : ''}`
        : 'Voir ma liste d’envies'
    );
  });
}

function removeProductFromWishlistPage(productId) {
  const selector = `[data-wishlist-item][data-product-id="${CSS.escape(String(productId))}"]`;
  const items = [...document.querySelectorAll(selector)];

  items.forEach((item) => {
    const section = item.closest('[data-wishlist-section]');
    const carousel = item.closest('slideshow-component');
    const removableElement = carousel ? item.closest('slideshow-slide') || item : item;

    item.classList.add('wishlist-item--removing');

    window.setTimeout(() => {
      removableElement.remove();

      if (!section || section.querySelector('[data-wishlist-item]')) return;

      if (carousel) carousel.hidden = true;

      const emptyState = section.querySelector('[data-wishlist-empty-state]');

      if (emptyState) {
        emptyState.hidden = false;
        emptyState.focus?.({ preventScroll: true });
      }
    }, 220);
  });
}

function announce(button, message) {
  const container = button.closest('[data-wishlist-add-button-block]');
  const status = container?.querySelector('[data-wishlist-status]');

  if (status) status.textContent = message;
}
